import React, { Component } from 'react'
import $ from 'jquery'
import logoAkademie from '../img/logo_akademie.jpg'
import logoBonifatius from '../img/logo_bonifatius.jpg'

// <br/><a className='idea-contact-link' href='mailto:Info@erinnerte-zukunft.de'>Info@erinnerte-zukunft.de</a>

var TEXTS = {
  'tw': {
    'name': 'Thomas Würtz',
    'bio': 'Thomas Würtz studierte Islamwissenschaft, Politikwissenschaft und Philosophie in Bamberg und Kairo. Promotion zur Islamischen Theologie im 14. Jahrhundert an der Universität Zürich. Er war als Dozent im Fach Islamwissenschaft an den Universitäten Zürich, Bern, Aarhus (Dänemark) und an der Freien Universität Berlin tätig. Daneben Aktivitäten im interreligiösen Dialog in Zusammenarbeit mit der Schweizer Jesuitenmission vor allem in Lahore (Pakistan). Seit 2016 ist er wissenschaftlicher Referent an der Katholischen Akademie in Berlin.'
  },
  'sa': {
    'name': 'Sarah Albrecht',
    'bio': 'Sarah Albrecht studierte Islamwissenschaft, Religions- und Politikwissenschaft in Berlin und Damaskus und promovierte zu Debatten um die Auslegung islamischer Normen im Westen. Sie lehrt als wissenschaftliche Mitarbeiterin an der Freien Universität Berlin und ist nebenbei als Referentin in der Erwachsenenbildung und im interreligiösen Kontext tätig.'
  },
  'mvm': {
    'name': 'Marie von Manteuffel',
    'bio': "Marie von Manteuffel ist Rechtsanwältin in Berlin. Seit März 2016 setzt sie sich als Geschäftsführerin des 'Katholischen Forums Leben in der Illegalität' für die Verbesserung der Lebenssituation von Menschen ohne Aufenthaltstitel in Deutschland ein. 2010 arbeitete sie als wissenschaftliche Assistentin in Jerusalem. Im Jahr 2015 begann sie ihr Engagement für Bildungsprojekte im Libanon mit dem Ziel, Nothilfe mit Versöhnungsarbeit im Aufnahmestaat zu verbinden."
  },
  'kv': {
    'name': 'Katrin Visse',
    'bio': 'Katrin Visse studierte Katholische Theologie und Islamwissenschaft in Berlin, Tübingen und Damaskus und ist Referentin für Islam und Theologie an der Katholischen Akademie in Berlin. Im Rahmen dieser Arbeit und der darin gemachten Erfahrungen entstand im Jahre 2015 aus vielen vertrauensvollen Gesprächen mit Muslimen und Christen die Idee „Erinnerte Zukunft“.'
  }
}

export default class Idea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedMember: ''
    }
  }

  showBio (key, event) {
    $(document.querySelectorAll('.idea-names-bio--' + key)).toggle(1000)
  }

  render () {
    return <section id='umsetzung' className='idea'>
             <h3 className='idea-title'>Umsetzung</h3>
             <div className='idea-names'>
               {Object.entries(TEXTS).map((t) => {
                  return <div key={t[0]} className='idea-names-entry'>
                           <div className={'idea-names-name' + (this.state.selectedMember !== t[0] ? '' : ' idea-names-name--selected')} onClick={this.showBio.bind(this, t[0])}>
                             {t[1].name}
                           </div>
                           <div className={'idea-names-bio idea-names-bio--' + t[0]}>
                             {t[1].bio}
                           </div>
                         </div>
                })}
             </div>
             <div className='idea-contact'>
               Kontakt:
               <br /><a className='idea-contact-link' href='mailto:Wuertz@katholische-akademie-berlin.de'>Wuertz@katholische-akademie-berlin.de</a>
             </div>
             <div className='idea-logo'>
               <a href='https://www.katholische-akademie-berlin.de' target='_blank' rel='noopener'><img className='idea-logo-akademie' src={logoAkademie} alt='Logo Katholische Akademie in Berlin e.V.' /></a>
               <a href='http://www.bonifatiuswerk.de/' target='_blank' rel='noopener'><img className='idea-logo-bonifatius' src={logoBonifatius} alt='Logo bonifatius werk' /></a>
             </div>
           </section>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/idea.js
 **/